import LabServiceModel from "@/models/LabServiceModel";

export default class ScheduleStatusModel extends LabServiceModel {
  modelName() {
    return 'schedule-status';
  }
  defaults() {
    return {
      id: null,
      status: null,
      description: null,
      order: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      schedule_status_logs: [],
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      status: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      order: String,
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }
  validation() {
    return {}
  }
  icon() {
    return this.getIcon();
  }
  getIcon() {
    switch (this.status) {
      case ScheduleStatusModel.statusDraft:
        return 'traffic-stop';
      case ScheduleStatusModel.statusApproved:
        return 'traffic-go';
      default:
        return 'traffic-light';
    }
  }
  getVariant() {
    switch (this.status) {
      case ScheduleStatusModel.statusDraft:
        return 'warning';
      case ScheduleStatusModel.statusApproved:
        return 'success';
      case ScheduleStatusModel.statusDeclined:
        return 'danger';
      default:
        return 'dark';
    }
  }
  static get statusDraft() {
    return 'Draft';
  }
  static get statusApproved() {
    return 'Approved';
  }
  static get statusDeclined() {
    return 'Declined';
  }

}
